<template>
<div>
    <appBar />

    <!-- HERO / PAGE TITLE -->
    <section class="news-hero py-16">
        <v-container class="text-center">
            <h1 class="hero-title">{{ $t('Media & Updates') }}</h1>
            <p class="hero-subtitle">{{ $t('MediaHero.Subtitle') }}</p>
        </v-container>
    </section>

    <!-- ================= INSTAGRAM POSTS ================= -->
    <section v-if="instagramPosts.length" class="instagram-section py-10">
        <v-container>
            <div class="text-center mb-10">
                <h2 class="section-title">{{ $t('InstagramSection.Title') }}</h2>
                <p class="section-subtitle">{{ $t('InstagramSection.Subtitle') }}</p>
            </div>

            <v-row dense class="gap-6">
                <v-col v-for="(post, index) in instagramPosts" :key="index" cols="12" sm="6" md="4">
                    <a :href="post.permalink" target="_blank" class="insta-card">
                        <img v-if="post.media_type === 'IMAGE' || post.media_type === 'CAROUSEL_ALBUM'" :src="post.media_url" :alt="$t('InstagramSection.ImageAlt')" class="insta-image" loading="lazy" />
                        <video v-else-if="post.media_type === 'VIDEO'" :src="post.media_url" controls muted playsinline class="insta-image"></video>

                        <div class="insta-overlay">
                            <v-icon size="32" color="white">mdi-instagram</v-icon>
                            <p class="insta-caption">{{ post.caption ? post.caption : $t('InstagramSection.NoCaption') }}</p>
                        </div>
                    </a>
                </v-col>
            </v-row>
        </v-container>
    </section>

    <!-- ================= GALLERY SECTION ================= -->
    <section v-if="galleryImages.length" class="gallery-section py-10">
        <v-container>
            <div class="text-center mb-10">
                <h2 class="section-title">{{ $t('GallerySection.Title') }}</h2>
                <p class="section-subtitle">{{ $t('GallerySection.Subtitle') }}</p>
            </div>

            <v-row dense class="gap-6" justify="center" align="stretch">
                <v-col v-for="(img, index) in paginatedImages" :key="index" cols="12" sm="6" md="4" lg="3">
                    <div class="gallery-card" @click="openModal(index)">
                        <v-img :src="getImageUrl(img.image)" class="gallery-image" height="220px" cover></v-img>
                    </div>
                </v-col>
            </v-row>

            <v-pagination v-model="currentPage" :length="totalPages" color=" #2e7d32" rounded class="mt-8 custom-pagination" />
        </v-container>

        <!-- IMAGE MODAL -->
        <v-dialog v-model="modalOpen" max-width="900px">
            <v-card>
                <v-img :src="getImageUrl(galleryImages[modalIndex].image)" height="600px" cover></v-img>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="red" @click="modalOpen = false">
                        {{ $t('GallerySection.CloseButton') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>

    <!-- ================= OTHER NEWS & EVENTS ================= -->
    <section v-if="newsEvents.length" class="other-news-section py-10">
        <v-container>
            <div class="text-center mb-10">
                <h2 class="section-title">{{ $t('NewsSection.Title') }}</h2>
                <p class="section-subtitle">{{ $t('NewsSection.Subtitle') }}</p>
            </div>

            <v-row dense class="gap-6">
                <v-col v-for="(item, index) in newsEvents" :key="index" cols="12" md="6">
                    <div class="news-card elevation-0">
                        <v-img :src="item.image" height="220px" cover></v-img>
                        <div class="news-content">
                            <h3 class="news-title">{{ $t(`NewsSection.NewsItems.${index}.Title`) }}</h3>
                            <p class="news-date">{{ item.date }}</p>
                            <p class="news-description">{{ $t(`NewsSection.NewsItems.${index}.Description`) }}</p>
                            <a :href="item.link" class="read-more">{{ $t('NewsSection.ReadMore') }}</a>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </section>

    <Footer />
</div>
</template>

<script>
import axios from "axios";
import appBar from "../Layout/appBar.vue";
import Footer from "../Layout/Footer.vue";
import getColorImage from "@/mixins/getColorImage";

export default {
    name: "NewsPage",
    mixins: [getColorImage],
    components: {
        appBar,
        Footer
    },
    data() {
        return {
            instagramPosts: [],
            galleryImages: [],
            imagesPerPage: 8,
            currentPage: 1,
            modalOpen: false,
            modalIndex: 0,
            newsEvents: [
                // {
                //     title: "Community Workshop on Sustainable Farming",
                //     date: "Sep 15, 2025",
                //     description: "A hands-on workshop empowering local farmers on sustainable practices.",
                //     image: require("@/assets/beans.jpg"),
                // },
                // {
                //     title: "MNK Agriventures Featured in AgriNews",
                //     date: "Sep 10, 2025",
                //     description: "Our efforts in agribusiness innovation have been recognized in local media.",
                //     image: require("@/assets/mahindi.jpg"),
                // },
            ],
        };
    },
    mounted() {
        this.fetchInstagramPosts();
        this.fetchItems();
    },
    computed: {
        totalPages() {
            return Math.ceil(this.galleryImages.length / this.imagesPerPage);
        },
        paginatedImages() {
            const start = (this.currentPage - 1) * this.imagesPerPage;
            return this.galleryImages.slice(start, start + this.imagesPerPage);
        },
    },
    methods: {

        fetchItems() {
            axios.get('/published-gallery')
                .then(response => {
                    this.galleryImages = response.data.data;
                    console.log(this.galleryImages);
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        },
        fetchInstagramPosts() {
            axios.get('/instagram-posts?limit=6')
                .then(response => {
                    this.instagramPosts = response.data.data;
                    console.log(this.instagramPosts);
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        },
        openModal(index) {
            this.modalIndex = (this.currentPage - 1) * this.imagesPerPage + index;
            this.modalOpen = true;
        }

    },
};
</script>

<style scoped>
/* HERO */
.news-hero {
    background: #2e7d32;
    color: white;
    text-align: center;
    padding: 6rem 1rem;
}

.hero-subtitle {
    font-size: 1.2rem;
    line-height: 1.6;
    max-width: 700px;
    margin: 0 auto;
    font-style: italic;
}

/* INSTAGRAM */
.insta-card {
    position: relative;
    display: block;
    border-radius: 18px;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.insta-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.2);
}

.insta-image {
    width: 100%;
    height: 280px;
    object-fit: cover;
}

.insta-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(46, 125, 50, 0.55);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.insta-card:hover .insta-overlay {
    opacity: 1;
}

/* GALLERY */
.gallery-card {
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    background: #fff;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
}

.gallery-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 50px rgba(46, 125, 50, 0.2);
}

.gallery-image {
    width: 100%;
    height: 220px;
    object-fit: cover;
}

.gallery-info {
    padding: 0.8rem 1rem;
    text-align: center;
}

.gallery-info h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #2e7d32;
    margin: 0.2rem 0;
}

.gallery-info p {
    font-size: 0.9rem;
    color: #555;
    margin: 0;
}

/* NEWS & EVENTS */
.news-card {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    overflow: hidden;
    background: linear-gradient(145deg, #ffffff, #ececec);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.news-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
}

.news-content {
    padding: 1rem;
}

.news-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #2e7d32;
}

.news-date {
    font-size: 0.9rem;
    color: #b87c4c;
    margin: 0.2rem 0 0.5rem;
}

.news-description {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.5;
}

.read-more {
    display: inline-block;
    margin-top: 0.5rem;
    font-weight: 600;
    color: #2e7d32;
    text-decoration: none;
    transition: color 0.3s ease;
}

.read-more:hover {
    color: #b87c4c;
}

/* PAGINATION */
.custom-pagination .v-pagination__item {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    min-width: 0;
    font-weight: 600;
    margin: 0 4px;
}

.custom-pagination .v-pagination__item--active {
    background-color: #2e7d32 !important;
    color: white !important;
}

.insta-image {
    width: 100%;
    height: 350px;
    object-fit: cover;
    border-radius: 12px;
}
</style>
